import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import SalesChatWidget from './components/SalesChatWidget';

import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Auth from './pages/Auth';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import Success from './pages/Success';
import Checkout from './pages/Checkout';
import Admin from './pages/Admin';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Rules from './pages/Rules';
import RiskDisclosure from './pages/RiskDisclosure';
import RefundPolicy from './pages/RefundPolicy';
import Disclaimer from './pages/Disclaimer';
import { BestPropFirmBeginners, InstantFundingPropFirm, PropFirmIndia, CheapestPropFirm, HighestPayoutPropFirm, BlogIndex } from './pages/SEOPages';

import '@/App.css';
import { useAuth } from './contexts/AuthContext';

// Redirect logged-in users from Home to Dashboard
const HomeOrDashboard = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#050505]" />;
  if (user && user !== false) return <Navigate to="/dashboard" replace />;
  return <Home />;
};

// Redirect logged-in users from Auth to Dashboard
const AuthOrDashboard = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#050505]" />;
  if (user && user !== false) return <Navigate to="/dashboard" replace />;
  return <Auth />;
};

function AppRoutes() {
  const location = useLocation();
  // CRITICAL: Handle Google OAuth session_id in URL hash BEFORE any route renders
  if (location.hash && location.hash.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
      <Route path="/" element={<HomeOrDashboard />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/auth" element={<AuthOrDashboard />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/rules" element={<Rules />} />
      <Route path="/risk-disclosure" element={<RiskDisclosure />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/best-prop-firm-for-beginners" element={<BestPropFirmBeginners />} />
      <Route path="/instant-funding-prop-firm" element={<InstantFundingPropFirm />} />
      <Route path="/prop-firm-india" element={<PropFirmIndia />} />
      <Route path="/cheapest-prop-firm" element={<CheapestPropFirm />} />
      <Route path="/highest-payout-prop-firm" element={<HighestPayoutPropFirm />} />
      <Route path="/blog" element={<BlogIndex />} />

      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/success" element={<ProtectedRoute><Success /></ProtectedRoute>} />
      <Route path="/checkout/:planId" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
      </Routes>
      <SalesChatWidget />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
